import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
  hasAnyWebhookPermission as checkAnyWebhookPermission,
  hasWebhookPermission as checkWebhookPermission,
} from '../utils/permissions';

export function usePermissions() {
  const user = useSelector((state) => state.user.user);
  const loading = useSelector((state) => state.user.loading);

  const hasWebhookPermission = useCallback(
    (permissionCode) => checkWebhookPermission(user?.permissions, permissionCode),
    [user?.permissions],
  );

  const hasAnyWebhookPermission = useCallback(() => checkAnyWebhookPermission(user?.permissions), [user?.permissions]);

  return {
    permissions: user?.permissions,
    loading,
    hasWebhookPermission,
    hasAnyWebhookPermission,
  };
}
